"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _pointerUtils = require("./pointer-utils");

var _nativeSelect = _interopRequireDefault(require("./native-select"));

var _dropdownSelect = _interopRequireDefault(require("./dropdown-select"));

var _withOptions = _interopRequireDefault(require("./with-options"));

var _propTypes2 = require("./prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Renders a select component as a native or dropdown style.
 */
var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
    _this.state = {
      // always native by default.  we'll determine when it mounts on the client
      SelectComponent: _nativeSelect.default
    };
    return _this;
  } // TODO: may have to update for React 16 - as cWM is deprecated


  _createClass(Select, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this$props = this.props,
          popover = _this$props.popover,
          multiple = _this$props.multiple; // Native is assumed better UI for coarsely-pointed devices (touch, switch, etc.)

      var DropdownSelectIfBest = (0, _pointerUtils.getPointerType)() === _pointerUtils.COARSE_POINTER ? _nativeSelect.default : _dropdownSelect.default; // select-multiple is a horrible UI on desktop browsers.
      // Always default to native for this case

      var SelectComponent = popover || multiple ? DropdownSelectIfBest : _nativeSelect.default;
      this.setState({
        SelectComponent: SelectComponent
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          unselected = _this$props2.unselected,
          otherProps = _objectWithoutProperties(_this$props2, ["unselected"]);

      var SelectComponent = this.state.SelectComponent;
      return _react.default.createElement(SelectComponent, _extends({
        unselected: unselected === true ? '' : unselected
      }, (0, _omit.default)(otherProps, ['popover', 'defaultValue'])));
    }
  }]);

  return Select;
}(_react.Component);

Select.displayName = 'Select';
Select.propTypes = _objectSpread({
  /** An array of options `[{ value, label }]`. See example. */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node,
    value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
    disabled: _propTypes.default.bool,

    /** Silence the maxLineLength error to allow a label > 21 characters. Generally only used in instances where copy or compliance requires them. */
    __dangerouslyAllowLongLabel: _propTypes.default.bool
  })),

  /** The currently selected value. Must match a provided option. */
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.bool, _propTypes.default.number, _propTypes.default.string]),

  /** Show the select in an error visual state. */
  error: _propTypes.default.bool,

  /** When true, sets width to 100% on the input. */
  fullWidth: _propTypes.default.bool,

  /** Shows a disabled style. */
  disabled: _propTypes.default.bool,

  /** A placeholder option when no value is selected. */
  unselected: _propTypes.default.oneOfType([
  /** true = blank label */
  _propTypes.default.bool,
  /** Custom label */
  _propTypes.default.string]),

  /** Allows selecting multiple options. */
  multiple: _propTypes.default.bool,

  /**
   * Displays options as a Checkbox/Radio list on finely-pointed (e.g.
   * mouse-driven) devices.
   */
  popover: _propTypes.default.bool,

  /** Id attribute for select element. */
  id: _propTypes.default.string.isRequired,

  /** Name attribute for select element. */
  name: _propTypes.default.string,

  /** Value change callback. */
  onChange: _propTypes.default.func,

  /** Focus callback. */
  onFocus: _propTypes.default.func,

  /** Blur callback. */
  onBlur: _propTypes.default.func,

  /**
   * The initial value when state is uncontrolled. Must match a provided
   * option.
   */
  defaultValue: _propTypes.default.string,

  /** Class on the <input> element. */
  className: _propTypes.default.string
}, _propTypes2.SELECT_PROP_TYPES);
Select.defaultProps = _propTypes2.SELECT_DEFAULT_PROPS;
var ExportedSelect = (0, _withOptions.default)(Select);
ExportedSelect.displayName = 'Select';
var _default = ExportedSelect;
exports.default = _default;